import { Component } from 'react';
import { findDOMNode } from 'react-dom';

export default class NodeResolver extends Component {
  componentDidMount() {
    // eslint-disable-next-line react/no-find-dom-node
    this.props.innerRef(findDOMNode(this));
  }

  componentWillUnmount() {
    this.props.innerRef(null);
  }

  render() {
    return this.props.children;
  }
}
